<template>
    <textarea :name="name" class="form-control" :id="id" :rows="rows" v-model="value">{{ value }}</textarea>
</template>

<script>
    export default {
        name: 'text-area',
        emits: ['update'],
        props: {
            id : {
                type: String
            },
            name : {
                type: String
            },
            rows: {
                type: String
            },
            selectedValue: {
                type: String
            },
        },
        data () {
            return {
                value : ''
            };
        },
        watch: {
            value: function(val) {
                this.$emit('update',val);
            },
            selectedValue: function(newVal, oldVal) {
                this.value  = newVal;
            }
        }
    }
</script>
